(function( $ ) {
    $(function() {

        // toggle menu icon
        $('.menu-icon').on('click', function () {
          $(this).addClass('opened');
        });
    });
})(jQuery);